import isCdsFrequentPassengerEnabled from './isCdsFrequentPassengerEnabled';

/**
 * Whether CDS Pasajero Frecuente header UI should render (mutually exclusive with Reserhub menu).
 * @param {object} features - Whitelabel feature flags.
 * @param {string} brand - Tenant brand slug.
 * @param {boolean} reserhubAccountEnabled - From useReserhubAccount().enabled.
 * @returns {boolean}
 */
export default function shouldShowCdsFrequentPassengerUi(features, brand, reserhubAccountEnabled) {
  if (reserhubAccountEnabled) return false;
  return isCdsFrequentPassengerEnabled(features, brand);
}
